import {CopilotIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import type {ComponentProps} from 'react'
import {useRef} from 'react'

export interface AskCopilotButtonProps extends Omit<
  ComponentProps<typeof IconButton>,
  'icon' | 'aria-label' | 'aria-labelledby'
> {
  referenceType: string
}

export function AskCopilotButton({children, referenceType, ...props}: AskCopilotButtonProps) {
  const contentRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <IconButton
        ref={contentRef}
        icon={CopilotIcon}
        size="small"
        aria-label={`Ask Copilot about this ${referenceType}`}
        tooltipDirection="n"
        data-testid="copilot-ask-menu"
        {...props}
      />
    </>
  )
}
